import escapeHtml from "escape-html";
import { Text } from "slate";

export const serialize = (node) => {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text);
    if (node.bold) {
      string = `<b>${string}</b>`;
    } else if (node.code) {
      string = `<code>${string}</code>`;
    } else if (node.italic) {
      string = `<i>${string}</i>`;
    } else if (node.underline) {
      string = `<u>${string}</u>`;
    }
    return string;
  }

  const children = node.children.map((n) => serialize(n)).join("");

  switch (node.type) {
    case "quote":
      return `<blockquote><p>${children}</p></blockquote>`;
    case "paragraph":
      return `${children}\n`;
    case "link":
      return `<a href="${escapeHtml(
        node.url.startsWith("http") ? node.url : `https://${node.url}`,
      )}">${children}</a>`;
    default:
      return children;
  }
};
